import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarInstitucionesConfiguracion, limpiarInstitucionesConfiguracion, obtenerNivelConfiguracion, limpiarNivelConfiguracion } from '../../../actions/configuracion';

import NuevaInstitucion from './NuevaInstitucion';
import EditarInstitucion from './EditarInstitucion';
import EliminarInstitucion from './EliminarInstitucion';

const Instituciones = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Niveles educativos',
            path: '/configuracion/educacion'
        },
        {
            activo: true,
            nombre: 'Instituciones',
            path: '/configuracion/educacion/instituciones/'
        }
    ];

    const dispatch =  useDispatch();

    const { id } = useParams();

    const { listado_instituciones, detalles } = useSelector(state => state.configuracion.educacion);

    const [instituciones, setInstituciones] = useState([]);

    const [institucionAgregar, setInstitucionAgregar] = useState(null);
    const [institucionEditar, setInstitucionEditar] = useState(null);
    const [institucionEliminar, setInstitucionEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true, 
            selector: row => row.nombre,
        },
        {
            name: 'Nivel',
            sortable: true, 
            selector: row => row.nivel,
        },
        {
            name: 'Jovenes relacionados',
            sortable: true, 
            selector: row => row.jovenes,
        },
        {
            name: '',
            cell: row => {
                if(row._id){
                    return(
                        <div className="text-right w-100">
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarInstitucion(row)}><i className="fas fa-trash text-danger"></i></button>
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarInstitucion(row)}><i className="fas fa-edit text-warning"></i></button>
                        </div>
                    )
                }else{
                    return(<></>)
                }
            }
        }
    ];

    /* Crear institucion */
    const handleAgregarInstitucion = (institucion) => {
        setInstitucionEditar(null);
        setInstitucionEliminar(null);

        setInstitucionAgregar(institucion);        
    }

    /* Editar institucion */
    const handleEditarInstitucion = (institucion) => {
        setInstitucionAgregar(null);
        setInstitucionEliminar(null);

        setInstitucionEditar(institucion);
    }

    /* Eliminar institucion */
    const handleEliminarInstitucion = (institucion) => {
        setInstitucionAgregar(null);
        setInstitucionEditar(null);

        setInstitucionEliminar(institucion);
    }

    useEffect(() => {
        return () => {
            dispatch(limpiarNivelConfiguracion());
            dispatch(limpiarInstitucionesConfiguracion());
        }
    }, []);

    useEffect(() => {        
        if(id){
            dispatch(obtenerNivelConfiguracion(id));
            dispatch(buscarInstitucionesConfiguracion(id));

            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        setInstituciones(listado_instituciones);
    }, [listado_instituciones]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <NuevaInstitucion institucion={institucionAgregar} reestablecerInstitucion={handleAgregarInstitucion} />
            <EditarInstitucion institucion={institucionEditar} reestablecerInstitucion={handleEditarInstitucion} />
            <EliminarInstitucion institucion={institucionEliminar} reestablecerInstitucion={handleEliminarInstitucion} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="mb-3 mt-5">Instituciones{detalles ? ' de ' + detalles.nombre : ''}</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarInstitucion({ id })}>Agregar institución</button>
                    </div>

                    <div className="mt-2">
                        <DataTable 
                            columns={columns}
                            data={instituciones}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Instituciones;